const supportedLanguages = { 'pt': 'pt', 'en': 'en', 'fr': 'fr' };

export default supportedLanguages;